module.exports = __webpack_public_path__ + "img/appAsset--metrics-branch-ax.94bab8b7.svg";